<template>
  <div id="app2">
    <router-view />
    <div id="nav" v-show="debug">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/tablet">tablet</router-link> |
    </div>
    <div v-show="debug">NODE_ENV : {{ env }}</div>
  </div>
</template>

<script>
import * as Modal from "./modal/ModalEvent";
import { EventEmitter } from "events";

export default {
  name: "App",
  computed: {
    debug() {
      return this.$store.getters["config/debug"];
    },
    env() {
      return process.env.NODE_ENV;
    }
  },
  beforeCreate() {
    window.evt = new EventEmitter();
  },
  mounted() {
    if (!this.$store.state.device.isOKDevice) {
      Modal.showEnv()
    }
  }
};
</script>

<style scoped>
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
